module.exports = __webpack_public_path__ + "media/images/menu/horologium-a0876bfa77bda9fb882f0d83c875294b.jpg";